import { afterNextRender, Directive, DestroyRef, inject } from '@angular/core';
import { MinHeightPanelComponent } from './min-height-panel.component';

@Directive({
  selector: '[tdWbMinHeightPanelTrigger]',
  exportAs: 'tdWbMinHeightPanelTrigger'
})
export class MinHeightPanelTriggerDirective {
  private readonly destroyRef = inject(DestroyRef);
  private readonly minHeightPanelComponent = inject(MinHeightPanelComponent);

  constructor() {
    afterNextRender(() => {
      this.minHeightPanelComponent.addTrigger();
    });

    this.destroyRef.onDestroy(() => {
      this.minHeightPanelComponent.removeTrigger();
    });
  }
}
